var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsultation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 528.14,
    height: 330.612,
    viewBox: "0 0 528.14 497.612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a0616a;\n      }\n\n      .cls-2 {\n        fill: #44bba4;\n      }\n\n      .cls-3 {\n        fill: #ccc;\n      }\n\n      .cls-4 {\n        fill: #2f2e41;\n      }\n\n      .cls-5 {\n        fill: #9e616a;\n      }\n\n      .cls-6 {\n        fill: #3f3d56;\n      }\n\n      .cls-7 {\n        fill: #e6e6e6;\n      }\n\n      .cls-8 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-883.15 -300.13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-1",
    d: "M405.348,314.032a22.026,22.026,0,0,0,22.026,25.6l53.954,156.993,34.427-23.66L449.3,315.73a22.145,22.145,0,0,0-43.949-1.7Z",
    transform: "translate(544 112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-2",
    d: "M686.955,367.15c-23.96,27.26-83.04,75.3-131.71,108.38-10.52,7.15-20.56,13.59-29.65,18.98-6.14,3.64-11.85,6.79-16.99,9.36a27.995,27.995,0,0,1-38.41-14.5l-33.7-81.53,11.66-7.73,28.75-19.07,6.53-4.32,26.96,64.21,28.43-22.82,17.65-14.17,80.46-64.57,6.94-2.06,16.19,15.8,11.45,11.18,10.77,1.87C683.9,366.44,685.455,366.77,686.955,367.15Z",
    transform: "translate(544 112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-2",
    d: "M727.185,454.55l-3.02,207.41-243.96-7,38.96-86c-.28-2.76,17.1-22.13,17-25-.3-8.41,5.98-16.2,7-25,2.08-18.15-9.83-86.69-4.34-100.85a96.27,96.27,0,0,1,8.94-18.08c3.12-4.72,6.32-7.9,9.38-9.05l9.02-21.02,8-12,62.77-18.59,6.94-2.06,16.19,15.8,11.45,11.18,10.77,1.87c1.61.28,3.17.61,4.67.99a47.442,47.442,0,0,1,19.66,9.74C725.415,392.86,727.6,422.9,727.185,454.55Z",
    transform: "translate(544 112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-3",
    d: "M867.29,660.4q-10.32,12.945-21.87,24.82l-26.38.02-141.87.16-25.54.03-16.98.02-25.26.02-19.43.02-35.89.04-21.17.03-44.58.04-21.28.03-58.97.06-37.04.04-9.94.01q-3.315-3.39-6.53-6.88-8.01-8.685-15.41-17.91l20.58-.02,14.02-.01,32.46-.04,62.64-.06,21.17-.02,8.56-.01h.03l6.72-.01,3.01-.01,7.71-.01h3.26l22.86-.02,49.31-.06,21.7-.02,20.78-.02,19.48-.02,27.95-.03,149.28-.15Z",
    transform: "translate(544 112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-4",
    d: "M529.766,348.972l-.054.005a10.924,10.924,0,0,1-11.89-9.865l-5.687-60.7a81.473,81.473,0,0,1,3.433-32.257,82.787,82.787,0,0,1,39.23-47.592,81.52,81.52,0,0,1,31.251-9.557c44.82-4.27,61.2,5.065,88.885,73.421s5.7,60.792,5.7,60.792a10.944,10.944,0,0,1-.463,4.339,11.122,11.122,0,0,1-5.285,6.393,10.979,10.979,0,0,1-4.179,1.277c-52.987,13.468-106.452,27.645-140.946,13.744Z",
    transform: "translate(544 112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    className: "cls-5",
    d: "M628.387,246.521a60.1,60.1,0,0,1-61.112,92.67,59.4,59.4,0,0,1-38.241-25.165A60.1,60.1,0,0,1,590.1,221.382a59.4,59.4,0,0,1,38.287,25.141Z",
    transform: "translate(544 112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-4",
    d: "M493.346,285.156a64.45,64.45,0,0,1,2.716-25.512c.6-20.147,6.45-38.4,31.023-37.63a64.48,64.48,0,0,1,24.552-7.534l12.143-1.2.409-.039a64.341,64.341,0,0,1,70.026,58.1l.114,1.216-25.691,2.512L597.581,251.41l.546,24.694-13.269,1.3-5.576-11.938.272,12.451c-19.7,17.352-49.576,18.261-86.082,8.454Z",
    transform: "translate(544 112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-4",
    d: "M575.525,342.755a10.75,10.75,0,0,0,1,5.834,10.994,10.994,0,0,0,1.687,2.561,11.122,11.122,0,0,0,1.956,1.744,10.906,10.906,0,0,0,7.3,1.9q.241-.025.482-.059t.48-.079q.242-.043.48-.1t.478-.122l8.966-2.513L608.4,323.906l2.3,24.587,40.773-11.352L641.7,232.806l-69.495,6.848,1.906,1.835a48.029,48.029,0,0,1,13.032,22.516,78.292,78.292,0,0,1,1.983,26.562,141.186,141.186,0,0,1-4.977,26.588,208.077,208.077,0,0,1-7.855,22.633A10.982,10.982,0,0,0,575.525,342.755Z",
    transform: "translate(544 112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-6",
    d: "M584.792,671.709a8.061,8.061,0,0,1-3.454-.781l-192.52,4.912a8.08,8.08,0,0,1,1.15-15.045L515.921,623.24a8.08,8.08,0,0,1,4.016-.154l194.826,23.747a8.079,8.079,0,0,1,.926,15.535l-128.259,8.9A8.09,8.09,0,0,1,584.792,671.709Z",
    transform: "translate(544 112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9-2",
    "data-name": "Path 9",
    className: "cls-4",
    d: "M591.872,658.307a5.085,5.085,0,0,1-2.483-.646l-156.354,7.305a5.068,5.068,0,0,1,1.283-9.346l56.6-13.738a5.084,5.084,0,0,1,2.677.078l145.354-.175a5.069,5.069,0,0,1,.034,9.683l-45.6,6.608a5.057,5.057,0,0,1-1.513.23Z",
    transform: "translate(544 112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10-2",
    "data-name": "Path 10",
    className: "cls-1",
    d: "M575.415,649.974A22.026,22.026,0,0,0,607.67,639.96l165.5,13-8-41-170.7-1.626a22.145,22.145,0,0,0-19.053,39.64Z",
    transform: "translate(544 112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-2",
    d: "M673.165,382.96s25-20,55,16C748.4,423.238,787.424,570,790.66,630.822a27.982,27.982,0,0,1-28.584,29.461l-88.211-1.535L664,603.3l69.643.825Z",
    transform: "translate(544 112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-6",
    d: "M574.084,671.732a22.739,22.739,0,0,1-8.81-1.784L386.832,674.02a22.675,22.675,0,0,1-13.651-24.582l-6.63-156.711a22.642,22.642,0,0,1,23.935-19.074l165.663,6.871a22.739,22.739,0,0,1,20.922,26.544L596.48,652.835a22.775,22.775,0,0,1-22.4,18.9Z",
    transform: "translate(544 112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13-2",
    "data-name": "Path 13",
    className: "cls-7",
    d: "M438.585,205.17l-74.47-.21a7.541,7.541,0,0,0-7.55,7.51l-.27,98.61a7.524,7.524,0,0,0,7.5,7.54l41.31.12,33.17.09a7.526,7.526,0,0,0,7.54-7.51l.02-5.83.26-92.77a7.535,7.535,0,0,0-7.51-7.55Z",
    transform: "translate(544 112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-8",
    d: "M433.335,211.06l-64-.18a7.061,7.061,0,0,0-7.07,7.03l-.18,63.4A31.443,31.443,0,0,0,393.4,312.8l12.16.03,27.49.08a7.055,7.055,0,0,0,7.07-7.03l.02-6.38.22-81.37a7.055,7.055,0,0,0-7.03-7.07Z",
    transform: "translate(544 112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    className: "cls-2",
    d: "M426.145,254.38h-49.9a2.995,2.995,0,0,0,0,5.99h49.9a2.995,2.995,0,0,0,0-5.99Z",
    transform: "translate(544 112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    className: "cls-2",
    d: "M387.215,237.96h-10.97a3,3,0,0,0,0,5.99h10.97a2.995,2.995,0,1,0,0-5.99Z",
    transform: "translate(544 112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    className: "cls-2",
    d: "M426.145,280.71h-49.9a2.995,2.995,0,0,0,0,5.99h49.9a2.995,2.995,0,0,0,0-5.99Z",
    transform: "translate(544 112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    className: "cls-2",
    d: "M426.145,267.55h-49.9a2.99,2.99,0,0,0,0,5.98h49.9a2.99,2.99,0,0,0,0-5.98Z",
    transform: "translate(544 112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-2",
    d: "M416.449,248.55a17.716,17.716,0,1,1,17.716-17.716,17.716,17.716,0,0,1-17.716,17.716Zm0-34.2a16.485,16.485,0,1,0,16.485,16.485,16.485,16.485,0,0,0-16.485-16.485Z",
    transform: "translate(544 112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "cls-2",
    d: "M423.889,237.7a45.546,45.546,0,0,0-7.478-17.566.935.935,0,0,0-1.595,0,48.647,48.647,0,0,0-6.067,18.336c-.144,1.177,1.7,1.167,1.847,0a45.521,45.521,0,0,1,1.211-6.2,1.056,1.056,0,0,0,.206-.063,13.46,13.46,0,0,1,7.95-1.295c.024,0,.046,0,.07,0a44.287,44.287,0,0,1,2.075,7.278C422.334,239.353,424.114,238.859,423.889,237.7ZM412.472,230a46.744,46.744,0,0,1,3.225-7.618,44.266,44.266,0,0,1,3.566,6.612A15.577,15.577,0,0,0,412.472,230Z",
    transform: "translate(544 112)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultation);
export default __webpack_public_path__ + "static/media/consultation.611347a79edb26a473a0aaeb4562041c.svg";
export { ForwardRef as ReactComponent };